import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const CentralizedModalWrapper = styled.div`
  position: fixed;
  width: 445px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: ${fadeIn} 0.3s ease-out;
  z-index: 9999;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  border-bottom: 1px solid #d9dcdf;
  height: 40px;
  padding-inline: 16px;
`;

export const CloseButton = styled.span`
  font-size: 24px;
  color: #333;

  &:hover {
    color: #e05845;
  }

  cursor: pointer;
`;
